import {
  type ScriptProject,
  type ScriptProjectInput,
  scriptProjectSchema,
} from '@noconflict/contracts';
import type { Supabase } from '../../shared/api/supabase';

/** The intake details of a script project (RLS: whoever may read the project), or null when it has none. */
export async function getScriptProject(
  client: Supabase,
  projectId: string,
): Promise<ScriptProject | null> {
  const { data, error } = await client
    .from('script_projects')
    .select('*')
    .eq('project_id', projectId)
    .maybeSingle();
  if (error) throw new Error(error.message);
  return data ? scriptProjectSchema.parse(data) : null;
}

/**
 * Saves the details while the project is a draft; the project's name follows the title. Needs `projects.edit`,
 * and is refused with `project_not_draft` once the order has been submitted.
 */
export async function updateScriptProject(
  client: Supabase,
  projectId: string,
  input: ScriptProjectInput,
): Promise<void> {
  const { error } = await client.rpc('update_script_project', {
    p_project_id: projectId,
    p_production_type: input.productionType as string,
    p_title: input.title as string,
    p_episode_title: input.episodeTitle as string,
    p_episode_number: input.episodeNumber as string,
    p_producer: input.producer as string,
    p_authors: input.authors,
    p_time_periods: input.timePeriods,
    p_countries: input.countries,
    p_no_specific_country: input.noSpecificCountry,
    p_cities: input.cities,
    p_based_on_real: input.basedOnReal as boolean,
    p_based_on_real_note: input.basedOnRealNote as string,
    p_notes: input.notes as string,
  });
  if (error) throw new Error(error.message);
}
